import React from "react"
import moment from "moment"

import sheetConstants from "app/static/frontend/sheets/constants"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export const DateAndTimeCell = ({ rowId, columnId, children, sheetId, columnIndex, editing, ...props }) => (
    <CellWrapper {...props}>
        {children ? moment(children).local().format(sheetConstants.DATE_TIME_FORMAT) : undefined}
    </CellWrapper>
)
